import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11e76f7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "modalConfirm",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title fw-bold text-center w-100 fs-9" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_7 = { class: "pt-4" }
const _hoisted_8 = { class: "bg-gray p-2 mx-4 fw-bold d-flex" }
const _hoisted_9 = { class: "row px-4 mt-3" }
const _hoisted_10 = { class: "col-lg-12 stripe-table-no-header" }
const _hoisted_11 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_12 = { class: "col-lg-9 mt-2 d-flex fs-7" }
const _hoisted_13 = { class: "py-4" }
const _hoisted_14 = { class: "bg-gray p-2 mx-4 fw-bold d-flex" }
const _hoisted_15 = { class: "row px-4" }
const _hoisted_16 = { class: "col-lg-6 stripe-table" }
const _hoisted_17 = { class: "label-btn mt-3 bg-form d-flex justify-content-center align-items-center fw-bold" }
const _hoisted_18 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_19 = { class: "w-max-content col-lg-8 col-form-label" }
const _hoisted_20 = { class: "col-lg-3 mt-2 d-flex fs-7" }
const _hoisted_21 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_22 = { class: "w-max-content col-lg-8 col-form-label" }
const _hoisted_23 = { class: "col-lg-3 mt-2 d-flex fs-7" }
const _hoisted_24 = { class: "mb-5 mb-lg-0 row p-2 mx-0" }
const _hoisted_25 = { class: "w-max-content col-lg-8 col-form-label" }
const _hoisted_26 = { class: "col-lg-3 mt-2 d-flex fs-7" }
const _hoisted_27 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_28 = { class: "w-max-content col-lg-8 col-form-label" }
const _hoisted_29 = { class: "col-lg-3 mt-2 d-flex fs-7" }
const _hoisted_30 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_31 = { class: "w-max-content col-lg-8 col-form-label" }
const _hoisted_32 = { class: "col-lg-3 mt-2 d-flex fs-7" }
const _hoisted_33 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_34 = { class: "w-max-content col-lg-8 col-form-label" }
const _hoisted_35 = { class: "col-lg-3 mt-2 d-flex fs-7" }
const _hoisted_36 = { class: "col-lg-6 stripe-table" }
const _hoisted_37 = { class: "label-btn mt-3 bg-form d-flex justify-content-center align-items-center fw-bold" }
const _hoisted_38 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_39 = { class: "w-max-content col-lg-8 col-form-label" }
const _hoisted_40 = { class: "col-lg-3 mt-2 d-flex fs-7" }
const _hoisted_41 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_42 = { class: "w-max-content col-lg-8 col-form-label" }
const _hoisted_43 = { class: "col-lg-3 mt-2 d-flex fs-7" }
const _hoisted_44 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_45 = { class: "w-max-content col-lg-8 col-form-label" }
const _hoisted_46 = { class: "col-lg-3 mt-2 d-flex fs-7" }
const _hoisted_47 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_48 = { class: "w-max-content col-lg-8 col-form-label" }
const _hoisted_49 = { class: "col-lg-3 mt-2 d-flex fs-7" }
const _hoisted_50 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_51 = { class: "w-max-content col-lg-8 col-form-label" }
const _hoisted_52 = { class: "col-lg-3 mt-2 d-flex fs-7" }
const _hoisted_53 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_54 = { class: "w-max-content col-lg-8 col-form-label" }
const _hoisted_55 = { class: "col-lg-3 mt-2 d-flex fs-7" }
const _hoisted_56 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_57 = { class: "w-max-content col-lg-8 col-form-label" }
const _hoisted_58 = { class: "col-lg-3 mt-2 d-flex fs-7" }
const _hoisted_59 = { class: "row px-4" }
const _hoisted_60 = { class: "col-lg-12 stripe-table" }
const _hoisted_61 = { class: "label-btn mt-3 bg-form d-flex justify-content-center align-items-center fw-bold" }
const _hoisted_62 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_63 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_64 = { class: "col-lg-3 d-flex mt-2 fs-7 word-wrapper" }
const _hoisted_65 = { class: "col-lg-2 mt-2 d-flex fs-7" }
const _hoisted_66 = {
  key: 0,
  class: "col-lg-4 mt-2 fs-7 word-wrapper"
}
const _hoisted_67 = { class: "mb-5 mb-lg-0 row p-2 mx-0" }
const _hoisted_68 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_69 = { class: "col-lg-3 d-flex mt-2 fs-7 word-wrapper" }
const _hoisted_70 = { class: "col-lg-2 mt-2 d-flex fs-7" }
const _hoisted_71 = {
  key: 0,
  class: "col-lg-4 mt-2 fs-7 word-wrapper"
}
const _hoisted_72 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_73 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_74 = { class: "col-lg-3 d-flex mt-2 fs-7 word-wrapper" }
const _hoisted_75 = { class: "col-lg-2 mt-2 d-flex fs-7" }
const _hoisted_76 = {
  key: 0,
  class: "col-lg-4 mt-2 fs-7 word-wrapper"
}
const _hoisted_77 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_78 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_79 = { class: "col-lg-3 d-flex mt-2 fs-7 word-wrapper" }
const _hoisted_80 = { class: "col-lg-2 mt-2 d-flex fs-7" }
const _hoisted_81 = {
  key: 0,
  class: "col-lg-4 mt-2 fs-7 word-wrapper"
}
const _hoisted_82 = { class: "mb-5 mb-lg-0 row mx-0 p-2" }
const _hoisted_83 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_84 = { class: "col-lg-3 d-flex mt-2 fs-7 word-wrapper" }
const _hoisted_85 = { class: "col-lg-2 mt-2 d-flex fs-7" }
const _hoisted_86 = {
  key: 0,
  class: "col-lg-4 mt-2 fs-7 word-wrapper"
}
const _hoisted_87 = { class: "row px-4" }
const _hoisted_88 = { class: "col-lg-12" }
const _hoisted_89 = { class: "label-btn mt-3 bg-form d-flex justify-content-center align-items-center fw-bold" }
const _hoisted_90 = { class: "mb-5 mb-lg-0 row bg-light mx-0 p-2" }
const _hoisted_91 = { class: "d-flex align-items-center pt-2 fs-7 break-spaces text-break" }
const _hoisted_92 = { class: "mt-4 fw-bold text-center fs-7 border-bottom py-4 border-top" }
const _hoisted_93 = { class: "row mx-0 px-0 d-flex justify-content-center" }
const _hoisted_94 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center mb-4 mb-lg-0" }
const _hoisted_95 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center" }
const _hoisted_96 = {
  class: "modal fade",
  id: "modalSuccess",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_97 = { class: "modal-dialog" }
const _hoisted_98 = { class: "modal-content" }
const _hoisted_99 = { class: "modal-header" }
const _hoisted_100 = { class: "modal-title fs-7 fw-bold text-center w-100" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_102 = { class: "content mx-auto" }
const _hoisted_103 = { class: "text-center my-4 fs-7" }
const _hoisted_104 = { class: "modal-footer row mx-0 px-0 d-flex justify-content-center" }
const _hoisted_105 = { class: "d-flex col-lg-12 justify-content-center" }

import { onMounted, PropType, ref } from 'vue'
import { omit } from 'lodash'

import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import adminRegisterService from '@/services/admin-register-alumni.service'
import { InvitationKeyType } from '@/constants/type'
import { Modal } from 'bootstrap'
import { ALUMNI_QUESTION_TYPE } from '@/constants/common'


export default /*#__PURE__*/_defineComponent({
  props: {
  additionalData: Object as PropType<{
    addl_info_1_type: number
    addl_info_2_type: number
    addl_info_3_type: number
    addl_info_4_type: number
    addl_info_5_type: number
    addl_info_1_list: Array<string>
    addl_info_2_list: Array<string>
    addl_info_3_list: Array<string>
    addl_info_4_list: Array<string>
    addl_info_5_list: Array<string>
  }>,
  data: Object as PropType<{
    corporation_department_name: number
    corporation_period: number
    corporation_employee_id: number
    corporation_email: number
    corporation_name: number
    school_faclty_name: number
    school_department_name: number
    school_period: number
    school_student_id: number
    school_email: number
    school_name: number
    additional_information_1_question: string
    additional_information_1_setting?: any
    additional_information_1: number
    additional_information_2_question: string
    additional_information_2_setting?: any
    additional_information_2: number
    additional_information_3_question: string
    additional_information_3_setting?: any
    additional_information_3: number
    additional_information_4_question: string
    additional_information_4_setting?: any
    additional_information_4: number
    additional_information_5_question: string
    additional_information_5_setting?: any
    additional_information_5: number
    supplementary_information: string
    school_organization_name: string
    corporation_organization_name: string
  }>,
  invitationKeys: Array as PropType<Array<InvitationKeyType>>,
},
  setup(__props, { expose }) {

const props = __props



const updateFailed = ref<boolean>(false)
// 2022/09/15 TienNV Fix double click button confirm
const modalConfirm = ref()
const modalSuccess = ref()
onMounted(() => {
  modalConfirm.value = new Modal(document.getElementById('modalConfirm'))
  modalSuccess.value = new Modal(document.getElementById('modalSuccess'))
})
const loading = ref(false)

const normalizeArray = (additional_information_type, arr) => {
  //input ['1','2','',''] => ['1','2']
  //Type not show[0] => not send data list check => return []
  if (additional_information_type === 0 || arr?.length == 0) {
    return [] // if type = 0, return []
  }

  return arr?.filter((item) => item?.trim() !== '') // remove object empty
}

const PutEntry = async (): Promise<void> => {
  loading.value = true
  var dataEntry = omit(props.data, ['community_id', 'id'])
  props.invitationKeys?.forEach((invitationKey) => {
    dataEntry[`invited_route_name_${invitationKey.invited_route}`] = invitationKey.invited_route_name
  })
  dataEntry = {
    ...dataEntry,
    ...{
      additional_information_1_setting: {
        type: dataEntry.additional_information_1 == 0 ? 0 : props.additionalData?.addl_info_1_type || ALUMNI_QUESTION_TYPE.FREE_TEXT,
        data: dataEntry.additional_information_1 == 0 ? [] : normalizeArray(props.data?.additional_information_1, props.additionalData?.addl_info_1_list),
      },
      additional_information_2_setting: {
        type: dataEntry.additional_information_2 == 0 ? 0 : props.additionalData?.addl_info_2_type || ALUMNI_QUESTION_TYPE.FREE_TEXT,
        data: dataEntry.additional_information_2 == 0 ? [] : normalizeArray(props.data?.additional_information_2, props.additionalData?.addl_info_2_list),
      },
      additional_information_3_setting: {
        type: dataEntry.additional_information_3 == 0 ? 0 : props.additionalData?.addl_info_3_type || ALUMNI_QUESTION_TYPE.FREE_TEXT,
        data: dataEntry.additional_information_3 == 0 ? [] : normalizeArray(props.data?.additional_information_3, props.additionalData?.addl_info_3_list),
      },
      additional_information_4_setting: {
        type: dataEntry.additional_information_4 == 0 ? 0 : props.additionalData?.addl_info_4_type || ALUMNI_QUESTION_TYPE.FREE_TEXT,
        data: dataEntry.additional_information_4 == 0 ? [] : normalizeArray(props.data?.additional_information_4, props.additionalData?.addl_info_4_list),
      },
      additional_information_5_setting: {
        type: dataEntry.additional_information_5 == 0 ? 0 : props.additionalData?.addl_info_5_type || ALUMNI_QUESTION_TYPE.FREE_TEXT,
        data: dataEntry.additional_information_5 == 0 ? [] : normalizeArray(props.data?.additional_information_5, props.additionalData?.addl_info_5_list),
      },
    },
  }

  try {
    const response = await adminRegisterService.putEntryFormApi(props.data.community_id, { community_required_column: dataEntry })
    if (response?.status === 200) {
      updateFailed.value = false
    } else {
      updateFailed.value = true
    }
    //2022/09/15 TienNV Fix double click button confirm
    modalConfirm.value.hide()
    modalSuccess.value.show()
    setTimeout(() => {
      loading.value = false
    }, 2000)
  } catch (error) {
    console.log(error)
    updateFailed.value = false
    //2022/09/15 TienNV Fix double click button confirm
    modalConfirm.value.hide()
    modalSuccess.value.show()
    loading.value = false
  }
}

expose({
  showConfirmModal: (): void => modalConfirm.value.show(),
})

const radio = ref([
  {
    value: 0,
    title: translate('CG40unnecessary'),
  },
  {
    value: 1,
    title: translate('CG40required'),
  },
  {
    value: 2,
    title: translate('CG40any'),
  },
])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('CG41title')), 1),
            _hoisted_6
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(translate)('invitationUrl')), 1),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.invitationKeys, (invitationKey) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "mb-5 mb-lg-0 row mx-0 p-2",
                    key: invitationKey.invited_route
                  }, [
                    _createElementVNode("label", _hoisted_11, _toDisplayString(invitationKey.invited_route_name_default), 1),
                    _createElementVNode("div", _hoisted_12, _toDisplayString(invitationKey.invited_route_name || invitationKey.invited_route_name_default), 1)
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(translate)('OE30additionalItems')), 1),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(translate)('forCompanies')), 1),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("label", _hoisted_19, _toDisplayString(_unref(translate)('SA20corporationOrganizationName')), 1),
                  _createElementVNode("div", _hoisted_20, _toDisplayString(radio.value.find((item) => item.value === __props.data?.corporation_organization_name)?.title), 1)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("label", _hoisted_22, _toDisplayString(_unref(translate)('SA20department')), 1),
                  _createElementVNode("div", _hoisted_23, _toDisplayString(radio.value.find((item) => item.value === __props.data?.corporation_department_name)?.title), 1)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("label", _hoisted_25, _toDisplayString(_unref(translate)('enrollment')), 1),
                  _createElementVNode("div", _hoisted_26, _toDisplayString(radio.value.find((item) => item.value === __props.data?.corporation_period)?.title), 1)
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("label", _hoisted_28, _toDisplayString(_unref(translate)('SA20employeeID')), 1),
                  _createElementVNode("div", _hoisted_29, _toDisplayString(radio.value.find((item) => item.value === __props.data?.corporation_employee_id)?.title), 1)
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("label", _hoisted_31, _toDisplayString(_unref(translate)('enrolledTimeEmailID')), 1),
                  _createElementVNode("div", _hoisted_32, _toDisplayString(radio.value.find((item) => item.value === __props.data?.corporation_email)?.title), 1)
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("label", _hoisted_34, _toDisplayString(_unref(translate)('OE30nameAtTime')), 1),
                  _createElementVNode("div", _hoisted_35, _toDisplayString(radio.value.find((item) => item.value === __props.data?.corporation_name)?.title), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, _toDisplayString(_unref(translate)('forSchool')), 1),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("label", _hoisted_39, _toDisplayString(_unref(translate)('SA20schoolOrganizationName')), 1),
                  _createElementVNode("div", _hoisted_40, _toDisplayString(radio.value.find((item) => item.value === __props.data?.school_organization_name)?.title), 1)
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("label", _hoisted_42, _toDisplayString(_unref(translate)('SA20facultyName')), 1),
                  _createElementVNode("div", _hoisted_43, _toDisplayString(radio.value.find((item) => item.value === __props.data?.school_faclty_name)?.title), 1)
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("label", _hoisted_45, _toDisplayString(_unref(translate)('SA20departmentName')), 1),
                  _createElementVNode("div", _hoisted_46, _toDisplayString(radio.value.find((item) => item.value === __props.data?.school_department_name)?.title), 1)
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("label", _hoisted_48, _toDisplayString(_unref(translate)('SA20periodOfEnrollment')), 1),
                  _createElementVNode("div", _hoisted_49, _toDisplayString(radio.value.find((item) => item.value === __props.data?.school_period)?.title), 1)
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("label", _hoisted_51, _toDisplayString(_unref(translate)('SA20studentID')), 1),
                  _createElementVNode("div", _hoisted_52, _toDisplayString(radio.value.find((item) => item.value === __props.data?.school_student_id)?.title), 1)
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("label", _hoisted_54, _toDisplayString(_unref(translate)('SA20emailAttendSchool')), 1),
                  _createElementVNode("div", _hoisted_55, _toDisplayString(radio.value.find((item) => item.value === __props.data?.school_email)?.title), 1)
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("label", _hoisted_57, _toDisplayString(_unref(translate)('SA20nameAtSchool')), 1),
                  _createElementVNode("div", _hoisted_58, _toDisplayString(radio.value.find((item) => item.value === __props.data?.school_name)?.title), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, _toDisplayString(_unref(translate)('additionalInformation')), 1),
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("label", _hoisted_63, _toDisplayString(_unref(translate)('additionalInformation1Question')), 1),
                  _createElementVNode("div", _hoisted_64, _toDisplayString(__props.data?.additional_information_1_question), 1),
                  _createElementVNode("div", _hoisted_65, _toDisplayString(radio.value.find((item) => item.value === __props.data?.additional_information_1)?.title), 1),
                  (__props.additionalData?.addl_info_1_type !== _unref(ALUMNI_QUESTION_TYPE).FREE_TEXT && __props.data?.additional_information_1 !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.additionalData?.addl_info_1_list, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", { key: index }, [
                            _createElementVNode("div", null, _toDisplayString(item), 1)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("label", _hoisted_68, _toDisplayString(_unref(translate)('additionalInformation2Question')), 1),
                  _createElementVNode("div", _hoisted_69, _toDisplayString(__props.data?.additional_information_2_question), 1),
                  _createElementVNode("div", _hoisted_70, _toDisplayString(radio.value.find((item) => item.value === __props.data?.additional_information_2)?.title), 1),
                  (__props.additionalData?.addl_info_2_type !== _unref(ALUMNI_QUESTION_TYPE).FREE_TEXT && __props.data?.additional_information_2 !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.additionalData?.addl_info_2_list, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", { key: index }, [
                            _createElementVNode("div", null, _toDisplayString(item), 1)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_72, [
                  _createElementVNode("label", _hoisted_73, _toDisplayString(_unref(translate)('additionalInformation3Question')), 1),
                  _createElementVNode("div", _hoisted_74, _toDisplayString(__props.data?.additional_information_3_question), 1),
                  _createElementVNode("div", _hoisted_75, _toDisplayString(radio.value.find((item) => item.value === __props.data?.additional_information_3)?.title), 1),
                  (__props.additionalData?.addl_info_3_type !== _unref(ALUMNI_QUESTION_TYPE).FREE_TEXT && __props.data?.additional_information_3 !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.additionalData?.addl_info_3_list, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", { key: index }, [
                            _createElementVNode("div", null, _toDisplayString(item), 1)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_77, [
                  _createElementVNode("label", _hoisted_78, _toDisplayString(_unref(translate)('additionalInformation4Question')), 1),
                  _createElementVNode("div", _hoisted_79, _toDisplayString(__props.data?.additional_information_4_question), 1),
                  _createElementVNode("div", _hoisted_80, _toDisplayString(radio.value.find((item) => item.value === __props.data?.additional_information_4)?.title), 1),
                  (__props.additionalData?.addl_info_4_type !== _unref(ALUMNI_QUESTION_TYPE).FREE_TEXT && __props.data?.additional_information_4 !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.additionalData?.addl_info_4_list, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", { key: index }, [
                            _createElementVNode("div", null, _toDisplayString(item), 1)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_82, [
                  _createElementVNode("label", _hoisted_83, _toDisplayString(_unref(translate)('additionalInformation5Question')), 1),
                  _createElementVNode("div", _hoisted_84, _toDisplayString(__props.data?.additional_information_5_question), 1),
                  _createElementVNode("div", _hoisted_85, _toDisplayString(radio.value.find((item) => item.value === __props.data?.additional_information_5)?.title), 1),
                  (__props.additionalData?.addl_info_5_type !== _unref(ALUMNI_QUESTION_TYPE).FREE_TEXT && __props.data?.additional_information_5 !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.additionalData?.addl_info_5_list, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", { key: index }, [
                            _createElementVNode("div", null, _toDisplayString(item), 1)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_87, [
              _createElementVNode("div", _hoisted_88, [
                _createElementVNode("div", _hoisted_89, _toDisplayString(_unref(translate)('supplementaryInformation')), 1),
                _createElementVNode("div", _hoisted_90, [
                  _createElementVNode("div", _hoisted_91, _toDisplayString(__props.data?.supplementary_information), 1)
                ])
              ])
            ]),
            _createElementVNode("p", _hoisted_92, _toDisplayString(_unref(translate)('updateQuestion')), 1),
            _createElementVNode("div", _hoisted_93, [
              _createElementVNode("div", _hoisted_94, [
                _createVNode(Button, {
                  title: _unref(translate)('titleButtonEdit'),
                  type: 'secondary',
                  className: 'fw-bold',
                  "data-bs-dismiss": "modal"
                }, null, 8, ["title"])
              ]),
              _createElementVNode("div", _hoisted_95, [
                _createVNode(Button, {
                  title: _unref(translate)('update'),
                  type: 'secondary',
                  className: 'fw-bold',
                  onClick: PutEntry,
                  loading: loading.value,
                  disabled: loading.value
                }, null, 8, ["title", "loading", "disabled"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_96, [
      _createElementVNode("div", _hoisted_97, [
        _createElementVNode("div", _hoisted_98, [
          _createElementVNode("div", _hoisted_99, [
            _createElementVNode("h5", _hoisted_100, _toDisplayString(_unref(translate)('CG42title')), 1),
            _hoisted_101
          ]),
          _createElementVNode("div", _hoisted_102, [
            _createElementVNode("div", _hoisted_103, _toDisplayString(updateFailed.value ? _unref(translate)('CG40updateFailed') : _unref(translate)('updateComplete')), 1)
          ]),
          _createElementVNode("div", _hoisted_104, [
            _createElementVNode("div", _hoisted_105, [
              _createVNode(Button, {
                title: _unref(translate)('close'),
                type: 'secondary',
                "data-bs-dismiss": "modal",
                className: 'fw-bold'
              }, null, 8, ["title"])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})